function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52306",
  "data-name": "Path 52306",
  d: "M0,0H18.614V18.614H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_52307",
  "data-name": "Path 52307",
  d: "M6.559,16.827h0a1.163,1.163,0,0,1-1.684-1.235L5.5,12,2.861,9.464h0A1.163,1.163,0,0,1,3.5,7.47L7.17,6.946l1.656-3.3h0a1.163,1.163,0,0,1,2.085,0l1.656,3.3,3.668.524h0a1.163,1.163,0,0,1,.641,1.994L14.234,12l.627,3.6h0a1.163,1.163,0,0,1-1.684,1.235l-3.309-1.71Z",
  transform: "translate(-0.561 -0.672)",
  fill: "#1dbf73"
});

function SvgStarFavorite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star-favorite",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.614,
    height: 18.614,
    viewBox: "0 0 18.614 18.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFavorite);
export default __webpack_public_path__ + "static/media/star-favorite.d6765d95.svg";
export { ForwardRef as ReactComponent };